import { post, postFile } from "../../helpers/api";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main";

const state = {
  items: [],
  isLoadingData: true,
  isBtnLoading: false,
  isBtnEditLoading: false,
  search: "",
  isShowResultDialog: false,
  resultMsg: "",
  isSuccess: false,
  serverOptions: {
    page: 1,
    rowsPerPage: 15,
  },
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
    state.isLoadingData = false;
  },
  SET_IS_BTN_LOADING(state, isBtnLoading) {
    state.isBtnLoading = isBtnLoading;
  },
  SET_IS_BTN_EDIT_LOADING(state, isBtnEditLoading) {
    state.isBtnEditLoading = isBtnEditLoading;
  },
  REMOVE_ITEM(state, id) {
    state.items = state.items.filter((item) => item.au_id !== id);
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  SET_DELETE_SUCCESS(state, value) {
    state.isShowResultDialog = value.state;
    state.resultMsg = value.msg;
    state.isSuccess = value.isSuccess;
  },
  SET_IS_LOADING_DATA(state, isLoadingData) {
    state.isLoadingData = isLoadingData;
  },
  SET_SERVER_OPTIONS(state, options) {
    state.serverOptions = { ...state.serverOptions, ...options };
  },
};

const actions = {
  async getItems({ commit }, payload) {
    commit("SET_IS_LOADING_DATA", true);
    try {
      return post(
        "app-user/get-pagination",
        {
          page: payload.page || 1,
          rowsPerPage: payload.rowsPerPage || 15,
          search: payload.search || "",
          sortBy: payload.sortBy || "au_id",
          sortType: payload.sortType || "desc",
        },
        {
          id: 6,
          action: "view",
        }
      )
        .then((response) => {
          commit("SET_ITEMS", response.data.data || response.data);
          commit("SET_IS_BTN_LOADING", false);
          commit("SET_IS_BTN_EDIT_LOADING", false);
          commit("SET_IS_LOADING_DATA", false);
          return response;
        })
        .catch((error) => {
          console.log(error);
          commit("SET_IS_LOADING_DATA", false);
          return error;
        });
    } catch (error) {
      console.log(error);
      commit("SET_IS_LOADING_DATA", false);
      return error;
    }
  },
  async addNewItem({ commit }, payload) {
    const formData = new FormData();
    formData.append("au_name", payload.au_name);
    formData.append("au_email", payload.au_email || "");
    if (payload.au_password) {
      formData.append("au_password", payload.au_password);
    }
    formData.append("au_type", payload.au_type);
    formData.append("au_provider_id", payload.au_provider_id);
    formData.append("au_phone", payload.au_phone || "");
    formData.append("au_city", payload.au_city || "");
    formData.append("au_address", payload.au_address || "");
    formData.append("au_token_firebase", payload.au_token_firebase || "");
    if (payload.au_image) {
      formData.append("au_image", payload.au_image);
    }
    if (payload.file) {
      formData.append("file", payload.file);
    }

    return postFile(
      "app-user/store",
      formData,
      {
        id: 6,
        action: "add",
      }
    )
      .then((response) => {
        this.dispatch("app_user/getItems", { page: 1 });

        const t = i18n.global.t;
        toast("success", t("added_successfully"));
        return response;
      })
      .catch((error) => {
        commit("SET_IS_BTN_LOADING", false);

        const t = i18n.global.t;
        if (error.response?.status === 408) {
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return error;
        }

        toast("error", t("something_wrong"));
        console.log(error);
        return error;
      });
  },
  async deleteItem({ commit }, id) {
    post(
      "app-user/delete/" + id,
      {},
      {
        id: 6,
        action: "delete",
      }
    )
      .then((response) => {
        this.dispatch("app_user/getItems", { page: 1 });

        const t = i18n.global.t;
        toast("success", t("deleted_successfully"));
        return response;
      })
      .catch((error) => {
        const t = i18n.global.t;
        this.dispatch("app_user/getItems", { page: 1 });
        commit("SET_IS_BTN_LOADING", false);
        if (error.response?.status === 408) {
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return;
        }

        if (
          error.response?.data?.message?.includes(
            "Cannot delete or update a parent row"
          )
        ) {
          commit("SET_DELETE_SUCCESS", {
            state: true,
            msg: t(
              "you_can_not_delete_this_item_because_there_are_related_items"
            ),
            isSuccess: false,
          });
        } else {
          commit("SET_DELETE_SUCCESS", {
            state: true,
            msg: t("something_wrong"),
            isSuccess: false,
          });
        }
      });
  },
  async editItem({ commit }, payload) {
    const formData = new FormData();
    formData.append("au_name", payload.au_name);
    formData.append("au_email", payload.au_email || "");
    if (payload.au_password) {
      formData.append("au_password", payload.au_password);
    }
    formData.append("au_type", payload.au_type);
    formData.append("au_provider_id", payload.au_provider_id);
    formData.append("au_phone", payload.au_phone || "");
    formData.append("au_city", payload.au_city || "");
    formData.append("au_address", payload.au_address || "");
    formData.append("au_token_firebase", payload.au_token_firebase || "");
    if (payload.au_image) {
      formData.append("au_image", payload.au_image);
    }
    if (payload.file) {
      formData.append("file", payload.file);
    }

    return postFile(
      "app-user/edit/" + payload.au_id,
      formData,
      {
        id: 6,
        action: "edit",
      }
    )
      .then((response) => {
        this.dispatch("app_user/getItems", { page: 1 });

        const t = i18n.global.t;
        toast("success", t("edited_successfully"));
        return response;
      })
      .catch((error) => {
        commit("SET_IS_BTN_EDIT_LOADING", false);

        const t = i18n.global.t;
        if (error.response?.status === 408) {
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return error;
        }
        toast("error", t("something_wrong"));
        console.log(error);
        return error;
      });
  },
};

const getters = {
  getResultDialog: (state) => state.isShowResultDialog,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
